module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "part-h1"
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AGNETISMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("For it’s well known that bodies act one upon another by the attractions of gravity, magnetism, and electricity; and these instances shew the tenor and course of Nature, and make it not improbable but that there may be more attractive forces than these")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-right1"
  }, [_c('span', [_vm._v("—Sir Isaac Newton,")])]), _vm._v(" "), _c('p', {
    staticClass: "part-right1a"
  }, [_c('span', [_c('i', [_vm._v("Optics")]), _vm._v(" 1717")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left11"
  }, [_c('span', [_c('i', [_vm._v("Wherever law ends, tryanny begins …")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-right3"
  }, [_c('span', [_vm._v("—John Locke,")])]), _vm._v(" "), _c('p', {
    staticClass: "part-right11"
  }, [_c('span', [_c('i', [_vm._v("Second Treatise of Government")]), _vm._v(" 1689")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 75
// module chunks = 0